import { AuthForm } from './components';
import {
	AuthContext,
	useAuthContext,
	AuthProvider,
	AuthConsumer,
} from './context';
import * as authUtils from './utils';

const Auth = {
	Context: AuthContext,
	Provider: AuthProvider,
	Consumer: AuthConsumer,
	useAuthContext,
	AuthForm,
	authUtils,
}

export { Auth };
